import { render, staticRenderFns } from "./SendBundleSave.vue?vue&type=template&id=06c89f30&scoped=true&"
import script from "./SendBundleSave.vue?vue&type=script&lang=js&"
export * from "./SendBundleSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c89f30",
  null
  
)

export default component.exports